import styled from 'styled-components';

export const StyledSearchWrapper = styled.div`
  .ant-input-affix-wrapper {
    display: flex !important;
  }

  input {
    background: white;
  }

  .anticon {
    vertical-align: 0.125em;
  }

  .ant-input-clear-icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const UserSessionsTableWrapper = styled.div`
  flex: 1;
  margin: 0 8px;
`;
export const UserSessionsTableHeader = styled.div`
  height: 50px;
  line-height: 50px;
  position: relative;

  &:first-child .BaseTable__header-cell-text {
    padding-left: 7.5px;
  }

  .BaseTable__header-cell {
    padding-right: 16px;
  }

  .BaseTable__header-cell-text {
    white-space: nowrap;
  }

  .BaseTable__sort-indicator {
    margin-right: 3px;
  }

  & button {
    position: absolute;
    right: 4px;
    top: 10px;
    border: none;
    background: none;
  }

  &:hover {
    .BaseTable__header-cell {
      padding-right: 34px;
    }

    button {
      display: inline-flex;
    }
  }
`;

export const CellWrapper = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  min-width: 90%;
  position: relative;

  .action-bar {
    display: none;
  }

  &:hover {
    .action-bar {
      display: block;
      position: absolute;
      right: 0;
      background: #e9f3fd;
      margin-left: 5px;
    }
  }
`;
